import unhead_KgADcZ0jPj from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/runner/work/certificates-app/certificates-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/certificates-app/certificates-app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_5j40ijIZYu from "/home/runner/work/certificates-app/certificates-app/node_modules/@nuxtjs/plausible/dist/runtime/plugin.client.js";
import nuxt_plugin_tCgj7NI28J from "/home/runner/work/certificates-app/certificates-app/node_modules/@noemission/nuxt-delay-hydration/dist/runtime/nuxt-plugin.mjs";
import plugin_client_xSLIPjreZL from "/home/runner/work/certificates-app/certificates-app/node_modules/nuxt-meta-pixel/dist/runtime/plugin.client.mjs";
import api_QQzOodE9HA from "/home/runner/work/certificates-app/certificates-app/plugins/api.js";
import cio_client_GVPZbPWWVt from "/home/runner/work/certificates-app/certificates-app/plugins/cio.client.js";
import feedbackFish_client_S0o8ePpf28 from "/home/runner/work/certificates-app/certificates-app/plugins/feedbackFish.client.js";
import grafana_client_jGF9op8sVg from "/home/runner/work/certificates-app/certificates-app/plugins/grafana.client.js";
import gtag_client_R70iZRv6jK from "/home/runner/work/certificates-app/certificates-app/plugins/gtag.client.js";
import gtm_client_KEcT5dOoKs from "/home/runner/work/certificates-app/certificates-app/plugins/gtm.client.js";
import helpscout_client_xq2lQEfwLE from "/home/runner/work/certificates-app/certificates-app/plugins/helpscout.client.js";
import kissmetrics_hMynreyPPi from "/home/runner/work/certificates-app/certificates-app/plugins/kissmetrics.js";
import mixpanel_flxmgVYaFE from "/home/runner/work/certificates-app/certificates-app/plugins/mixpanel.js";
import new_relic_client_bqEYVpsBER from "/home/runner/work/certificates-app/certificates-app/plugins/new-relic.client.js";
import partnero_client_U32YBuUqzk from "/home/runner/work/certificates-app/certificates-app/plugins/partnero.client.js";
import prism_client_yDIApfQXmT from "/home/runner/work/certificates-app/certificates-app/plugins/prism.client.js";
import reCaptcha_client_k7ZnKXUFg8 from "/home/runner/work/certificates-app/certificates-app/plugins/reCaptcha.client.js";
import rightMessage_client_TtCjP3wKRX from "/home/runner/work/certificates-app/certificates-app/plugins/rightMessage.client.js";
import setTheme_4fDvX5jy6A from "/home/runner/work/certificates-app/certificates-app/plugins/setTheme.js";
import vueCountdown_client_EohQcN259Q from "/home/runner/work/certificates-app/certificates-app/plugins/vueCountdown.client.js";
import vueInlineSvg_SPJbldAP8W from "/home/runner/work/certificates-app/certificates-app/plugins/vueInlineSvg.js";
import plugin_auto_pageviews_client_x3Y8XIaaPY from "/home/runner/work/certificates-app/certificates-app/node_modules/@nuxtjs/plausible/dist/runtime/plugin-auto-pageviews.client.js";
export default [
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_5j40ijIZYu,
  nuxt_plugin_tCgj7NI28J,
  plugin_client_xSLIPjreZL,
  api_QQzOodE9HA,
  cio_client_GVPZbPWWVt,
  feedbackFish_client_S0o8ePpf28,
  grafana_client_jGF9op8sVg,
  gtag_client_R70iZRv6jK,
  gtm_client_KEcT5dOoKs,
  helpscout_client_xq2lQEfwLE,
  kissmetrics_hMynreyPPi,
  mixpanel_flxmgVYaFE,
  new_relic_client_bqEYVpsBER,
  partnero_client_U32YBuUqzk,
  prism_client_yDIApfQXmT,
  reCaptcha_client_k7ZnKXUFg8,
  rightMessage_client_TtCjP3wKRX,
  setTheme_4fDvX5jy6A,
  vueCountdown_client_EohQcN259Q,
  vueInlineSvg_SPJbldAP8W,
  plugin_auto_pageviews_client_x3Y8XIaaPY
]